import React from 'react';

const TC_LEFT = [
  'STAVAN will only carry goods which is the property of the shipper and the shipper warrants that it is authorized to accept and is accepting these conditions not only on behalf of itself but also as agent for or on behalf of others who are or may thereafter become interested in the goods. The hereby undertake to indemnify STAVAN against any damages, cost and expenses resulting from any breach of warranty.',
  'STAVAN shall not be liable for any loss incurred due to causes beyond its control such as floods, accidents, fire, arson, loot civil commotion, terrorists act or default or omission committed by the shipper or Consignee or caused by situation beyond the control of STAVAN and for any loss arising due to confiscation of goods by any government or local authority. Subsequently, STAVAN will not be liable for any consequential loss or damage caused under the above mentioned circumstance.',
  'STAVAN will take full care in ensuring timely pick-up and delivery of the consignments. However, STAVAN under no circumstances will be liable for delay in pick up, Transportation or delivery of any consignments regardless of the cause of the delay.',
  'All damages or shortages must be reported in writing to STAVAN INTERNATIONAL LLP within 30 days of the issue of Lorry Receipts failing which STAVAN under no circumstances will be liable to entertain the complaints.',
  'STAVAN reserves the right to choose its route of routings the consignments which may change from time to time.',
  'STAVAN reserves the right to open / inspect any documents/ parcels/consignments in order to check misuse of our services by any unscrupulous people.',
  'STAVAN shall have a lien on the goods for all freight charges, custom duties, advances or charges of any kind arising out of this contract of carriage and may refuse to surrender possession of goods until such charges are paid.',
  'POD can be made available on specific request. However such request must be made within 30 days of the dispatch of the consignment, otherwise the same would not be entertained as a rule.',
  'Except as otherwise specifically provided in the contract, delivery of the goods will be made only to the consignee or the person to be notified by ordinary methods, STAVAN will not be liable for non-receipts or delay in receipts of such notice.',
  'The shipper shall comply with the all the applicable laws, customs and other government Regulations of any county to, through or over which the consignment may be carried including the those relating to the packing, carriage or delay of the goods and shall furnish such information and provide such documents as may be necessary to comply with such laws and regulations.',
  'All consignments carried under this consignment note are carried under CARRIER\'S ACT and the OWNER\'S RISK otherwise and until specifically agreed to by STAVAN by charging RISK CHARGES which at present are @ 5% of value of consignments under OWNER\'S RISK. STAVAN is not a common carrier and will only carry goods subject to these conditions.',
  'Consignors are advised to declare the value of document / parcels and get the same insured at their own cost to cover any loss/Damage/Delay and claim the damage, if any from the insurance agency.',
  'Octroi or any other charges levied by any Central, State or Local Authorities wherever applicable, will be payable extra by the Shipper / Consignee. Liability of STAVAN for any consequential losses, mis-delivery, delay or damages to any articles/documents/Parcels sent through it, is to the extent of Rs.100/- only.',
  'Any disputes arising out of this Consignment note/Transactions/Claim based on the same shall be decided/determined by any arbitrator to be appointed by the company and the arbitration proceedings shall be held at Ahmedabad only. All other litigations between and the sender and the company are subject to the jurisdiction of court of Ahmedabad only.',
  'The status and delivery details can be checked at STAVAN offices and website at www.stavan.co.in',
  'The business operations of M/s STAVAN INTERNATIONAL LLP are decentralized and operations autonomy is provided to respective operational regions. The Managing Directors/Director\'s/Proprietor of M/s STAVAN INTERNATIONAL LLP are not directly concerned with the day to day affairs of the Decentralized operation, as the operational empowerment and responsibility rest with the respective head regional business.',
];

const TC_RIGHT = [
  'Nature, contents, condition and value of the consignment are unknown to the STAVAN INTERNATIONAL LLP (herein after called the Company). The Carrier carries the goods as packed at owner\'s risk.',
  'The company shall not be liable for any loss or damage due to pilferage, theft, weather conditions, strikes, riots disturbances, fire explosion or accident etc.',
  'Delivery of goods should be taken from Company\'s godown within a week of their arrival failing which a godown rent will be charged. The consignor or consignee or other holder of the Receipt interested shall ascertain the date and time of arrival from the Company.',
  'The Company shall not be responsible if the goods are detained, retained, seized, or confiscated by Government authorities. The consignor shall be primarily liable to pay the transport charges and all other incidental charges if any at the Head Office of company or at any other agreed place.',
  'Where a Bank has agreed to accept this Lorry Receipt as a consignee/endorsee or holder thereof or in any other capacity for the purpose of giving advances to and/or collection or discounting bills of any of its customers whether before or after the entrustment of the goods to the Transport Operator, hereby agree in consideration of the same to hold themselves liable at all material times directly to the Bank concerned as if the Bank were a party to the contract herein contained with the right of recourse against the Transport Operator of the extent of the full value of the goods handed over to the Transport Operator for carriage storage and delivery.',
  'The Transport Operator undertakes to and shall deliver the goods in the like order and conditions as received subject to any deterioration in the condition of goods resulting from natural causes like effect of temperature weather conditions etc. to the Consignee Bank or his order or his assigns on the relative receipt being surrendered duly discharged by the Bank.',
  'The Transport Operator shall have the right to entrust the goods to any other lorry or service for transport in the event of the goods being so entrusted by the Transport Operator to another carrier, the other carrier shall as between the consignor, the Consignee Bank and the Transport Operator be agent so that the Transport Operator shall notwithstanding the delivery of the goods to the other carrier continue to be responsible for the safety of the goods and for their due delivery at the destination.',
  'The consignor shall be primarily liable to pay the transport charges and all other incidental charges, if any at the Head Office of the Transport Operator in Ahmedabad or at any other agreed place.',
  'The transport operator shall have the right to dispose of perishable goods lying undelivered after 48 hours of arrival without any notice. The Transport Operator shall have the right to dispose of other goods after 30 days of arrival after due notice in writing to the consignor, the Consignee Bank and the holder interested.',
  'In either case the Bank or claimant with Bank\'s authority shall be entitled to the proceeds less freight and demurrage and the Transport Operator shall render full accounts in him immediately after sale.',
  'Consignee Bank\'s Accepting Lorry Receipt will not be liable for payment of any charges arising out of any lien of the Transport Operator against the consignor or the buyer. Where it becomes necessary for any Bank to obtain delivery of the consignment from the Transport Operator, the Transport Operator shall deliver the goods unconditionally to the Bank on payment of the normal freight and storage charges only.',
  'Not with standing any statement made in this Lorry Receipt or any circumstances surrounding the issue of this Lorry Receipt, the Transport Operator shall at all time observe its obligation to the consignee Bank named in this Lorry Receipt and shall be responsible for safer and due delivery and for any loss or damage to the goods or consignment that arises as a result of negligence, default, failure to take reasonable precautions, malafides or criminal or fraudulent actions of the Transport Operator or any of its Managers, Agents, Employees, Partners, Directors or business associates or branches etc.',
  'The Consignor is responsible for all consequences of any incorrect or false declaration.',
  'Where the goods have been lost, destroyed, damaged or have been deteriorated, the compensation payable by the Transport Operator shall not exceed the value declared.',
];

const S = {
  page: { fontFamily: "'Times New Roman', Times, serif", fontSize: '9pt', color: '#000', background: '#fff', maxWidth: '210mm', margin: '0 auto', padding: '8mm', lineHeight: 1.3 },
  table: { width: '100%', borderCollapse: 'collapse' },
  cell: { border: '1px solid #000', padding: '3px 5px', verticalAlign: 'top', fontSize: '8.5pt' },
  bold: { fontWeight: 'bold' },
  label: { fontWeight: 'bold', fontSize: '8pt', display: 'block', marginBottom: '1px' },
  pre: { whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
};

const LrReceiptPrint = ({ formData, docketNo, companyName }) => {
  if (!formData) return null;
  const f = formData;
  const pkgs = f.packages || [];
  const displayCompany = companyName || 'STAVAN INTERNATIONAL LLP';

  return (
    <div style={{ background: '#fff' }}>
      {/* ====== PAGE 1: LR RECEIPT ====== */}
      <div style={{ ...S.page, pageBreakAfter: 'always' }} className="lr-print-page1">
        <style>{`
          @media print {
            body * { visibility: hidden !important; }
            .lr-print-page1, .lr-print-page1 * { visibility: visible !important; }
            .lr-print-page2, .lr-print-page2 * { visibility: visible !important; }
            .lr-print-page1 { position: absolute; top: 0; left: 0; width: 100%; }
            @page { size: A4 portrait; margin: 8mm; }
          }
        `}</style>

        {/* TOP HEADER: 3 zones */}
        <table style={{ ...S.table, marginBottom: '0' }}>
          <tbody>
            <tr>
              {/* Left: Logo */}
              <td style={{ ...S.cell, width: '28%', verticalAlign: 'top', padding: '5px 6px' }}>
                <div style={{ textAlign: 'center' }}>
                  <span style={{ fontSize: '20pt', fontWeight: 'bold', fontFamily: 'Impact, Arial Black, sans-serif', letterSpacing: '2px' }}>STAVAN</span>
                  <sup style={{ fontSize: '7pt', fontWeight: 'bold' }}>®</sup>
                </div>
                <div style={{ textAlign: 'center', fontSize: '7.5pt', fontStyle: 'italic', marginBottom: '4px' }}>Creators of Commitments</div>
                <div style={{ fontSize: '7pt', textAlign: 'center' }}>
                  Tel.: +91-40088280<br />
                  M. 9898872887 / 98980 10615<br />
                  Mail: admin@stavan.co.in<br />
                  http://www.stavan.co.in
                </div>
              </td>

              {/* Middle: Company & Remarks */}
              <td style={{ ...S.cell, width: '46%', verticalAlign: 'top', padding: '4px 6px' }}>
                <div style={{ textAlign: 'center', fontSize: '7.5pt', fontWeight: 'bold', marginBottom: '2px' }}>Subject to Ahmedabad Jurisdiction</div>
                <div style={{ textAlign: 'center', fontSize: '9pt', fontWeight: 'bold', marginBottom: '1px' }}>STAVAN INTERNATIONAL LLP</div>
                <div style={{ textAlign: 'center', fontSize: '7.5pt', marginBottom: '1px' }}>INTERNATIONAL FREIGHT FORWARDER /</div>
                <div style={{ textAlign: 'center', fontSize: '7.5pt', marginBottom: '3px' }}>LOGISTICS SERVICE PROVIDER / REFRIGERATED VEHICLE OPERATOR</div>
                <div style={{ border: '1px solid #000', padding: '3px', textAlign: 'center', marginBottom: '4px' }}>
                  <span style={{ fontSize: '7.5pt', fontWeight: 'bold' }}>CONSIGNOR COPY / CONSIGNEE COPY / TRANSPORTER COPY</span>
                </div>
                <div style={{ fontSize: '7.5pt', fontWeight: 'bold', marginBottom: '1px' }}>Remarks</div>
                <div style={{ fontSize: '7.5pt', minHeight: '18px', ...S.pre }}>{f.remarks || ''}</div>
              </td>

              {/* Right: Registered Office */}
              <td style={{ ...S.cell, width: '26%', verticalAlign: 'top', padding: '4px 6px' }}>
                <div style={{ fontSize: '7.5pt' }}>
                  <strong>Registered Office:</strong><br />
                  737-738 Sun Gravitas,<br />
                  Radio Mirchi Road, Vejalpur,<br />
                  Ahmedabad 380051,<br />
                  Gujarat, India.
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* ROW 2: GST / Insurance / CN / Vehicle */}
        <table style={{ ...S.table }}>
          <tbody>
            <tr>
              <td style={{ ...S.cell, width: '22%', verticalAlign: 'top' }}>
                <span style={S.label}>GST TAX PAYABLE BY</span>
                {['Consignor', 'Consignee', 'Transport'].map(opt => (
                  <div key={opt} style={{ fontSize: '8pt', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <span style={{ display: 'inline-block', width: '10px', height: '10px', border: '1px solid #000', textAlign: 'center', lineHeight: '10px', fontSize: '7pt' }}>
                      {f.service_tax_payable_by === opt ? '✓' : ''}
                    </span>
                    {opt.toUpperCase()}
                  </div>
                ))}
              </td>
              <td style={{ ...S.cell, width: '34%', verticalAlign: 'top' }}>
                <span style={S.label}>INSURANCE WILL BE TAKEN BY</span>
                <div style={{ fontSize: '8pt', marginBottom: '3px' }}>
                  {['Consignor', 'Consignee'].map(opt => (
                    <span key={opt} style={{ marginRight: '10px' }}>
                      <span style={{ display: 'inline-block', width: '9px', height: '9px', border: '1px solid #000', textAlign: 'center', lineHeight: '9px', fontSize: '7pt' }}>
                        {f.insurance_taken_by === opt ? '✓' : ''}
                      </span>
                      &nbsp;{opt}
                    </span>
                  ))}
                </div>
                <div style={{ fontSize: '8pt' }}><strong>Data Logger No.:</strong> {f.data_logger_no || ''}</div>
                <div style={{ fontSize: '8pt' }}><strong>Date Time:</strong> {f.date || ''}{f.time ? `.${f.time}` : ''}</div>
                <div style={{ fontSize: '8pt' }}><strong>Temp:</strong> {f.temp || ''}</div>
              </td>
              <td style={{ ...S.cell, width: '26%', verticalAlign: 'top' }}>
                <span style={S.label}>CONSIGNMENT NOTE</span>
                <div style={{ fontSize: '8pt' }}><strong>No.:</strong> {f.consignment_note_no || ''}</div>
                <div style={{ fontSize: '8pt' }}><strong>Date:</strong> {f.consignment_note_date || ''}</div>
              </td>
              <td style={{ ...S.cell, width: '18%', verticalAlign: 'top' }}>
                <span style={S.label}>VEHICLE No.</span>
                <div style={{ fontSize: '9pt', fontWeight: 'bold' }}>{f.vehicle_no || ''}</div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* ROW 3: Consignor / From */}
        <table style={{ ...S.table }}>
          <tbody>
            <tr>
              <td style={{ ...S.cell, width: '68%', minHeight: '55px', verticalAlign: 'top' }}>
                <span style={S.label}>Consignor Name &amp; Address</span>
                <div style={{ ...S.pre, fontSize: '8.5pt' }}>{f.consignor_name_address || ''}</div>
              </td>
              <td style={{ ...S.cell, width: '32%', verticalAlign: 'top' }}>
                <span style={S.label}>From</span>
                <div style={{ fontSize: '8.5pt' }}>{f.from_location || ''}</div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* ROW 4: Consignee / To */}
        <table style={{ ...S.table }}>
          <tbody>
            <tr>
              <td style={{ ...S.cell, width: '68%', minHeight: '55px', verticalAlign: 'top' }}>
                <span style={S.label}>Consignee Name &amp; Address</span>
                <div style={{ ...S.pre, fontSize: '8.5pt' }}>{f.consignee_name_address || ''}</div>
              </td>
              <td style={{ ...S.cell, width: '32%', verticalAlign: 'top' }}>
                <span style={S.label}>To</span>
                <div style={{ fontSize: '8.5pt' }}>{f.to_location || ''}</div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* Package Table */}
        <table style={{ ...S.table }}>
          <thead>
            <tr style={{ background: '#f5f5f5' }}>
              <th style={{ ...S.cell, ...S.bold, width: '10%', fontSize: '8pt' }}>Packages</th>
              <th style={{ ...S.cell, ...S.bold, width: '40%', fontSize: '8pt' }}>Description (Said to Contain)</th>
              <th style={{ ...S.cell, ...S.bold, width: '14%', fontSize: '8pt', textAlign: 'center' }}>
                <div>Weight</div>
                <div style={{ display: 'flex', justifyContent: 'space-around', fontSize: '7.5pt' }}>
                  <span>Actual</span><span>Charged</span>
                </div>
              </th>
              <th style={{ ...S.cell, ...S.bold, width: '18%', fontSize: '8pt', textAlign: 'center' }}>Rate</th>
              <th style={{ ...S.cell, ...S.bold, width: '18%', fontSize: '8pt', textAlign: 'center' }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {pkgs.map((p, i) => (
              <tr key={i}>
                <td style={{ ...S.cell, textAlign: 'center', fontSize: '8.5pt' }}>{p.packages || ''}</td>
                <td style={{ ...S.cell, fontSize: '8.5pt' }}>{p.description || ''}</td>
                <td style={{ ...S.cell }}>
                  <div style={{ display: 'flex', justifyContent: 'space-around', fontSize: '8.5pt' }}>
                    <span>{p.actual_weight || ''}</span>
                    <span>{p.charged_weight || ''}</span>
                  </div>
                </td>
                <td style={{ ...S.cell, textAlign: 'center', fontSize: '8.5pt' }}>{p.rate || ''}</td>
                <td style={{ ...S.cell, textAlign: 'center', fontSize: '8.5pt' }}>{p.amount || ''}</td>
              </tr>
            ))}
            {/* Extra blank rows if few packages */}
            {pkgs.length < 3 && Array.from({ length: 3 - pkgs.length }).map((_, i) => (
              <tr key={`blank-${i}`}>
                <td style={{ ...S.cell, height: '18px' }}></td>
                <td style={{ ...S.cell }}></td>
                <td style={{ ...S.cell }}></td>
                <td style={{ ...S.cell }}></td>
                <td style={{ ...S.cell }}></td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Footer: L Time / UL Time / Signature */}
        <table style={{ ...S.table }}>
          <tbody>
            <tr>
              <td style={{ ...S.cell, width: '25%', verticalAlign: 'top' }}>
                <div style={{ fontSize: '8pt' }}><strong>L Time:</strong> {f.l_time || ''}</div>
                <div style={{ fontSize: '8pt' }}><strong>Date:</strong> {f.l_date || ''}</div>
              </td>
              <td style={{ ...S.cell, width: '35%', verticalAlign: 'top' }}>
                <div style={{ fontSize: '8pt' }}><strong>UL Time:</strong> {f.ul_time || ''}</div>
                <div style={{ fontSize: '8pt' }}><strong>Date:</strong> {f.ul_date || ''}</div>
              </td>
              <td style={{ ...S.cell, width: '40%', verticalAlign: 'bottom', textAlign: 'right', minHeight: '50px' }}>
                <div style={{ fontSize: '8.5pt', fontWeight: 'bold', marginBottom: '25px' }}>For, {displayCompany}</div>
                <div style={{ borderTop: '1px solid #000', paddingTop: '3px', fontSize: '7.5pt' }}>Authorised Signature</div>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      {/* ====== PAGE 2: TERMS & CONDITIONS ====== */}
      <div style={{ ...S.page, pageBreakBefore: 'always' }} className="lr-print-page2">
        <div style={{ textAlign: 'center', marginBottom: '8px' }}>
          <span style={{ fontSize: '10pt', fontWeight: 'bold', textDecoration: 'underline' }}>TERMS &amp; CONDITIONS OF CARRIAGE — OWNER'S RISK</span>
        </div>
        <div style={{ textAlign: 'center', fontSize: '8pt', marginBottom: '8px' }}>
          <strong>STAVAN INTERNATIONAL LLP</strong> — All consignments are accepted and carried subject to the following conditions:
        </div>
        <table style={{ ...S.table }}>
          <tbody>
            <tr>
              <td style={{ ...S.cell, width: '50%', verticalAlign: 'top', padding: '4px 6px' }}>
                <ol style={{ paddingLeft: '12px', margin: 0 }}>
                  {TC_LEFT.map((item, i) => (
                    <li key={i} style={{ fontSize: '6.5pt', lineHeight: '1.3', marginBottom: '5px', textAlign: 'justify' }}>
                      {item}
                    </li>
                  ))}
                </ol>
              </td>
              <td style={{ ...S.cell, width: '50%', verticalAlign: 'top', padding: '4px 6px' }}>
                <ol style={{ paddingLeft: '12px', margin: 0 }}>
                  {TC_RIGHT.map((item, i) => (
                    <li key={i} style={{ fontSize: '6.5pt', lineHeight: '1.3', marginBottom: '5px', textAlign: 'justify' }}>
                      {item}
                    </li>
                  ))}
                </ol>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default LrReceiptPrint;
